// extracted by mini-css-extract-plugin
module.exports = {"banner":"MemberPricingBanner_banner__pFnj_","upgrade":"MemberPricingBanner_upgrade__LHu2P"};